import {
  useUserPermissions,
  hasPermission,
  type RbacResourceAccess,
} from '@wellesley/auth'

const requiredPermissions: Record<string, RbacResourceAccess> = {
  canEditGroup: {
    resource: 'GroupSettings',
    actions: ['Manage'],
  },
  canSeeMembers: {
    resource: 'GroupMembers',
    actions: ['Read'],
  },
  canManageGroupMembers: {
    resource: 'GroupMembers',
    actions: ['Manage'],
  },
  canInviteGroupMembers: {
    resource: 'GroupMembers',
    actions: ['Invite'],
  },
  canModerateGroupMembers: {
    resource: 'GroupMembers',
    actions: ['Moderate'],
  },
  canViewMemberRequests: {
    resource: 'GroupMembers',
    actions: ['Read'],
  },
  canManageGroupRequests: {
    resource: 'GroupMembers',
    actions: ['Manage'],
  },
  canDeleteGroup: {
    resource: 'GroupData',
    actions: ['Manage'],
  },
  canManageNotifications: {
    resource: 'GroupSettings',
    actions: ['Manage'],
  },
  canManageGroupSettings: {
    resource: 'GroupSettings',
    actions: ['Manage'],
  },
}

const useGroupPermissions = (groupId: string) => {
  const { userPermissions } = useUserPermissions(groupId)

  const canEditGroup = hasPermission(
    requiredPermissions.canEditGroup,
    userPermissions,
  )

  const canManageGroupSettings = hasPermission(
    requiredPermissions.canManageGroupSettings,
    userPermissions,
  )

  const canSeeMembers = hasPermission(
    requiredPermissions.canSeeMembers,
    userPermissions,
  )

  const canManageGroupMembers = hasPermission(
    requiredPermissions.canManageGroupMembers,
    userPermissions,
  )

  const canInviteGroupMembers = hasPermission(
    requiredPermissions.canInviteGroupMembers,
    userPermissions,
  )

  const canModerateGroupMembers = hasPermission(
    requiredPermissions.canModerateGroupMembers,
    userPermissions,
  )

  const canDeleteGroup = hasPermission(
    requiredPermissions.canDeleteGroup,
    userPermissions,
  )

  const canViewMemberRequests = hasPermission(
    requiredPermissions.canViewMemberRequests,
    userPermissions,
  )

  const canManageGroupRequests = hasPermission(
    requiredPermissions.canManageGroupRequests,
    userPermissions,
  )

  const canManageNotifications = hasPermission(
    requiredPermissions.canManageNotifications,
    userPermissions,
  )

  return {
    canSeeMembers,
    canEditGroup,
    canManageGroupMembers,
    canInviteGroupMembers,
    canModerateGroupMembers,
    canDeleteGroup,
    canManageNotifications,
    canViewMemberRequests,
    canManageGroupRequests,
    canManageGroupSettings,
  }
}

export default useGroupPermissions
